export default function sanitizePhone(phoneNumber: string): string {
  // Remove all non-digit characters
  let digits = phoneNumber.replace(/\D/g, '');

  // 420 is the Czech Republic country code; prepend it only if not already present
  if (!digits.startsWith('420')) {
    digits = `420${digits}`;
  }

  return `+${digits}`;
}
